import React from "react";
import {Col, Form, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import LabelInput from "../../../components/Common/LabelInput";
import {useDispatch} from "react-redux";
import * as yup from "yup";
import {useFormik} from "formik";
import {addOffice, modalOffice} from "../../../store/offices/actions";
import {IOfficeForm} from "../../../store/offices/types";

interface ModalOfficeProps {
    isOpen: boolean;
}

const ModalOffice: React.FC<ModalOfficeProps> = ({isOpen}) => {
    const dispatch = useDispatch();

    const validationSchema: yup.Schema<IOfficeForm> = yup.object().shape({
        name: yup.string()
            .min(1, "min 1 character")
            .max(75, "max 75 characters")
            .required("required"),
        prefix: yup.string()
            .min(1, "min 1 character")
            .matches(/^[a-zA-Z0-9_-]+$/, "Only latin symbols and numbers")
            .required("required"),
    });

    const initialValues: IOfficeForm = {
        name: "",
        prefix: ""
    }

    const handleSubmitForm = () => {
        dispatch(addOffice({name: values.name, prefix: values.prefix}))
    };

    const {
        values,
        handleChange,
        submitForm,
        handleBlur,
        errors,
        touched,
        isValid,
        resetForm,
    } = useFormik({
        initialValues: initialValues,
        onSubmit: handleSubmitForm,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true
    });

    const close = () => {
        dispatch(modalOffice(false));
        resetForm();
    };

    return (
        <Modal isOpen={isOpen} toggle={close}>
            <ModalHeader toggle={close} tag="h4">
                Add Office
            </ModalHeader>
            <ModalBody>
                <Form className="needs-validation">
                    <Row>
                        <Col xs={12}>
                            <div className="mb-3">
                                <LabelInput
                                    label="Name*"
                                    placeholder="Name*"
                                    name="name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name || ""}
                                    hasError={!!(errors.name && touched.name)}
                                    errorText={errors.name}
                                />
                            </div>
                            <div className="mb-3">
                                <LabelInput
                                    label="Prefix*"
                                    placeholder="Prefix*"
                                    name="prefix"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.prefix || ""}
                                    hasError={!!(errors.prefix && touched.prefix)}
                                    errorText={errors.prefix}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-success save-user"
                                    onClick={submitForm}
                                    disabled={!isValid}
                                > Save
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default ModalOffice;